<template>
  <div class="chatFrame">
    <div v-for="(item, index) in chatCardList" :key="index">
      <!-- 提问 -->
      <div class="quiz" v-animationStart v-if="item.type == 1">
        {{ item.value }}
      </div>
      <!-- 回答 -->
      <div
        style="display: flex"
        class="chatFrameMargin"
        v-if="item.type == 2"
        v-animationStart
      >
        <img class="flexImg" src="../image/header.png" alt="" />
        <div>
          <div class="answer">
            <div class="answerCenter" v-html="item.value"></div>
            <!-- <p
              class="answerTitle"
              v-if="item.source_documents && item.source_documents.length > 0"
            >
              出处：
            </p>
            <div
              class="chatCardFlex"
              v-if="item.source_documents && item.source_documents.length > 0"
            >
              <template v-for="(v, i) in item.source_documents">
                <div
                  class="chatCard cardLeft"
                  v-if="
                    (i < 1 && item.source_documents.length > 2) ||
                      item.source_documents.length <= 2 ||
                      isMore.includes(index)
                  "
                  :key="i"
                  @click="jump(v.link)"
                >
                  {{ v.type }} | {{ v.source }}
                </div>
              </template>
              <div
                v-if="item.source_documents.length > 2"
                class="chatCard"
                @click="spread(index)"
              >
                {{ !isMore.includes(index) ? '查看更多' : '收起' }}
              </div>
            </div> -->
          </div>
          <div class="operate" v-if="!item.isDefault">
            <div class="operateDiv">
              <i
                @click="getCopy(item)"
                style="width: 12px; height: 12px; font-size: 12px"
                class=" icon el-icon-document-copy copy-button"
              ></i>
            </div>
            <!-- 重新问答 -->
            <div class="operateDiv">
              <i
                style="width: 12px; height: 12px; font-size: 12px;padding: 0; margin: 0; border: 0;"
                @click="againProblem(item)"
                class="icon el-icon-refresh"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <chat-loading
      v-if="
        chatCardList.length > 0 &&
          chatCardList[chatCardList.length - 1].type == 1
      "
    ></chat-loading>
  </div>
</template>

<script>
/* eslint-disable */
var num = 0
import Clipboard from 'clipboard'
import chatLoading from '../chatLoading/index.vue'
export default {
  data() {
    return {
      chatCardList: [],
      isMore: []
    }
  },
  watch: {
    chatCardList(newName, oldName) {
      let { type } = newName[newName.length - 1]
      //  滚动条 滚动效果
      this.$nextTick(() => {
        this.com_height(type)
      })
    }
  },
  directives: {
    animationStart: {
      inserted: (el) => {
        setTimeout(() => {
          el.classList.add('flip-up')
        }, 300)
      }
    }
  },
  components: { chatLoading },
  methods: {
    clear() {
      this.chatCardList = []
    },
    //  copy
    /* eslint-disable */
    getCopy(item) {
      let clipboard = new Clipboard('.copy-button', {
        text: () => item.value.replace(/<br\/>/g, '')
      })
      clipboard.on('success', (e) => {
        this.$message({
          type: 'success',
          message: '复制成功!'
        })
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        this.$message({
          type: 'error',
          message: '复制失败!'
        })
      })
      return
    },
    up(item, r) {
      if (r === 'zan') {
        item.zan = 1
        item.low = 0
      } else {
        item.low = 1
        item.zan = 0
      }
      return this.userFeedback(item.qa_id, item.zan)
    },
    userFeedback(id, status) {
      this.$http.post(
        `/ika/user_feedback?qa_id=${id}&updater=${
          this.$store.state.user.username
        }&user_feedback=${status}`
      )
    },
    //  点击更多
    spread(index) {
      if (this.isMore.includes(index)) {
        this.isMore.splice(this.isMore.indexOf(index), 1)
      } else {
        this.isMore.push(index)
      }
    },
    init(res) {
      console.log('init', res)
      res.zan = 0
      res.low = 0
      if (res.type == 2) {
        // 初始化默认回答
        if (res.flag === 'start' && res.isDefault) {
          this.chatCardList.push(res)
        } else if (res.flag === 'start') {
          // 获取当前询问的问题是啥
          let problem = ''
          try {
            const obj = this.chatCardList[this.chatCardList.length - 1]
            if (obj.type == 1) {
              problem = obj.value
            }
          } catch (error) {}
          this.chatCardList.push(res)
          num = this.chatCardList.length - 1
          this.chatCardList[num].value = ''
          this.chatCardList[num].problem = problem
        } else if (res.flag === 'end') {
          // this.chatCardList[num].source_documents = JSON.parse(
          //   res.source_documents
          // ).docs
          this.$emit('returnList', this.chatCardList)
        } else {
          this.chatCardList[num].value += res.value
        }
      } else {
        this.chatCardList.push(res)
        this.$emit('returnList', this.chatCardList)
      }
      console.log('chatCardList', this.chatCardList)
    },
    jump(url) {
      return window.open(url, '_blank ')
    },
    // 重新回答
    againProblem(item) {
      console.log(item.problem)
      if (item.problem) {
        this.$emit('again', item.problem)
      }
    },
    //  计算最后文本高度
    com_height(type) {
      // eslint-disable-next-line
      let chatContent = document.querySelectorAll('.initPage')[0]
      // eslint-disable-next-line
      let chatReverse = document.querySelectorAll('.chatFrame')[0].offsetHeight
      let a = chatReverse - chatContent.offsetHeight + 80
      let H = 0
      if (type == 2) {
        let Tom = document.querySelectorAll('.quiz')
        let Hom = document.querySelectorAll('.chatFrameMargin')
        let TomH = Tom[Tom.length - 1].offsetHeight
        let HomH = Hom[Hom.length - 1].offsetHeight
        if (TomH + HomH - 457 > 0) {
          H = TomH + HomH - 457
          chatContent.scrollTop = a - 100 - H
        } else {
          chatContent.scrollTop = a + 80 + H
        }
      } else if (a > 0) {
        chatContent.scrollTop = a + 80 + H
      }
      return false
    }
  }
}
</script>

<style lang="stylus" scoped>
.chatFrame {
  width: 844px;
  margin 0 auto

  .flip-up {
    opacity: 1 !important;
    transform: translate(0px, 10px);
    transition: all 0.5s ease;
  }

  .chatFrameMargin {
    // margin-left: -65px;
    width: fit-content;
    opacity: 0;
  }

  .flexImg {
    width: 32px;
    height: 32px;
    margin-left: 24px;
    border-radius: 16px;
  }

  .operateDiv {
    .icon{
      width 20px !important;
      height 20px  !important;
      display flex;
      justify-content center;
      align-items center;
    }
    .icon:hover{
      background rgba(187,216,251,0.8);
      border-radius 3px;
      color #3B59F6
    }
    img {
      width: 11px;
      height: 11px;
    }
  }

  .operate {
    padding: 6px 8px;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 6px;
    display: flex;
    // margin: 5px 0 16px 700px;
    width: fit-content;
    cursor: pointer;
    float right ;
    margin-top 6px;
  }

  .cardLeft {
    text-align: left !important;
  }

  .answerCenter {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 23px;
    letter-spacing: 1px;
    text-align: left;
    width: 720px;
    white-space:pre-wrap
  }

  .quiz {
    padding: 14px;
    background: #325aff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    text-align: center;
    line-height: 23px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
    margin: 20px 0 16px 0;
    width: fit-content;
    max-width: 550px;
    text-align: left;
    opacity: 0;
    letter-spacing: 2px;
    margin-left: 65px;
  }

  .operateDiv {
    margin-right: 8px;
  }

  .operateDiv:last-child {
    margin-right: 0;
  }

  .answer {
    padding: 15px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    margin: 0 0 0 8px;
    width: fit-content;
    box-sizing: content-box;

    .answerTitle {
      width: fit-content;
      height: 14px;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.65);
      line-height: 14px;
      margin: 13px 0;
    }

    .chatCardFlex {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 570px;
    }

    .chatCard {
      width: 278px;
      height: 43px;
      background: rgba(50, 90, 255, 0.03);
      border-radius: 6px;
      text-align: center;
      line-height: 43px;
      padding: 0 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(47, 55, 89, 0.85);
      margin-left: 10px;
      margin-top: 10px;
      cursor: pointer;
    }

    .chatCard:nth-child(2n + 1) {
      margin-left: 0px;
    }
  }
}
</style>
